export var getTodayISODate = function getTodayISODate() {
  return new Date().toISOString();
};
export var sortDate = function sortDate(a, b) {
  var time1 = new Date(a).getTime();
  var time2 = new Date(b).getTime();
  if (time1 === time2) {
    return 0;
  }
  return time1 > time2 ? 1 : -1;
};
export var comparisonDateTime = function comparisonDateTime(a, b) {
  return sortDate(a, b) !== -1;
};
export var comparisonDateDay = function comparisonDateDay(a, b, c) {
  var date1 = new Date(a).getDay();
  var date2 = new Date(b).getDay();
  var time1 = new Date(a).getTime();
  var time2 = new Date(c).getTime();
  var isStartToDay = date1 === date2;
  var isToDay = time1 === time2;
  return !isStartToDay && isToDay ? 1 : 0;
};